import {WithId} from '@lifeislife/lifeislife-domain';


export function isSameRef<T extends WithId>(val1: T, val2: T): boolean {
  if (val1 == null && val2 == null) {
    return true;
  }
  if (val1 == null || val2 == null) {
    return false;
  }
  const id1 = val1['id'];
  const id2 = val2['id'];
  return id1 != null && id2 != null && id1 === id2;
}
